$(document).on('click', '.faculty-letter', function(event) {
    event.preventDefault();
    var href = $(this).attr('href');
    var offset  = $(href).offset().top;
    $('body, html').animate({
        scrollTop: offset - $('#header').outerHeight()
    }, 400);
}).on('change', '#schools-select', function(event) {
    event.preventDefault();
    var val = $(this).val();
    window.location.replace(val)
}).on('change', '#faculty-letter-select', function(event) {
    event.preventDefault();
    var val = $(this).val();
    var offset  = $(val).offset().top;
    $('body, html').animate({
        scrollTop: offset - $('#header').outerHeight()
    }, 400);
});
